module.exports = __webpack_public_path__ + "img/right-box-ru.294e7af1.png";